import { httpClient } from "./httpClient";

const updateEmployeeSalary = (idEmployeeSalary, formData) => {
  return httpClient.patch(`employeeSalary/${idEmployeeSalary}`, formData);
};

export default {
  updateEmployeeSalary
};